import get from 'lodash/get';
import toBoolean from '~/utils/toBoolean';
import { NOTIFICACTIONS_MANAGER_STATE } from '../constants';

export const userControlTokenSelector = state => {
  const notificationsManagerState = state[NOTIFICACTIONS_MANAGER_STATE];
  return get(notificationsManagerState, 'user.userControlToken', null);
};

export const emailSelector = state => {
  const notificationsManagerState = state[NOTIFICACTIONS_MANAGER_STATE];
  return get(notificationsManagerState, 'user.email', null);
};

export const userCredentialsSelector = state => {
  const notificationsManagerState = state[NOTIFICACTIONS_MANAGER_STATE];
  return get(notificationsManagerState, 'user');
};

export const hasUserCredentialsSelector = state => {
  const notificationsManagerState = state[NOTIFICACTIONS_MANAGER_STATE];
  return toBoolean(
    get(notificationsManagerState, 'user.email') &&
      get(notificationsManagerState, 'user.userControlToken')
  );
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/Authentication/selectors.js